import dayjs, { Dayjs } from 'dayjs';
import { DatePickerFormat } from '../model/format';

export const parseDateValue = (
  value: string | Dayjs | null | undefined,
  format?: DatePickerFormat,
): Dayjs | null => {
  if (!value) return null;

  if (typeof value !== 'string') {
    return value.isValid() ? value : null;
  }

  const parsedValue = dayjs(
    value,
    ['DD.MM.YYYY', 'DD.MM.YYYY HH:mm', 'YYYY-MM-DD'],
    true
  );

  if (parsedValue.isValid()) {
    return parsedValue;
  }

  if (/^\d{4}-\d{2}-\d{2}T/.test(value)) {
    const isoDate = dayjs(value);

    return isoDate.isValid() ? isoDate : null;
  }

  return null;
};